<template>
  <v-container>
    <address-search-form></address-search-form>
  </v-container>
</template>
<script>
import AddressSearchForm from "@/components/AddressSearchForm";
export default {
  name: "AddressSearch",
  components: {
    AddressSearchForm
  }
};
</script>